<template>
  <div style="height:100%;width: 100%">
    <v-toolbar
        dense        
        rounded
        style="z-index:1000; display:flex; width:80vw; margin:0 auto; margin-top:15px; justify-content:center"          
      >
        <v-text-field
          hide-details
          prepend-inner-icon="mdi-magnify"
          single-line
          solo
          placeholder="Search nearby events..."
          style="width:80vw"
        ></v-text-field>        
      </v-toolbar>    
    <l-map
      v-if="showMap"
      ref="eventsMap"
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      style="height: 120%;margin-top:-10vh;z-index:0"
      @click="clickHandler"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-marker @click="centerMarker" v-for="event in events" :key="event.id" :lat-lng="event.location">
        <l-popup class="popup">
          <div>
            <MapPopup :event='event' @joinEvent='joinEvent(event.id)' />            
          </div>
        </l-popup>
      </l-marker>
    </l-map>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 light-green lighten-2">
          Success!
        </v-card-title>

        <v-card-text class="my-3">
          <p class="font-weight-bold">{{dialogSubtitle}}</p>
          <p>{{dialogText}}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            class="light-green white--text"
            @click="dialog = false"
          >
            Okay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
    v-model="addEventDialog"
    width="500">
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Event!</span>
        </v-card-title>
        <v-card-text>
              <v-col cols="12">
                <v-text-field
                  label="Name"
                  required
                  prepend-icon="mdi-account"
                  color="light-green"
                  v-model="createEventName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-dialog
                  ref="dialog"
                  v-model="datePickerModal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      color="light-green"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    scrollable
                    color="light-green"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="light-green"
                      @click="datePickerModal = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="light-green"
                      @click="$refs.dialog.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="addEventDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="light-green white--text"
            text
            @click="selectEventLocation"
          >
            Select location >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      style="z-index:1000;padding-bottom:60px"
    >
      Click on a place to add the event!
    </v-snackbar>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import MapPopup from '../components/MapPopup';
import cacheEvents from '../eventDatabase';
import EventBus from '../bus';

export default {
  name: "MapPage",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    MapPopup,
  },
  data() {
    return {
      createEventName: "",
      snackbar:false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      datePickerModal: false,
      zoom: 13,
      center: latLng(47.41322, -1.219482),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(47.41322, -1.219482),
      withTooltip: latLng(47.41422, -1.250482),
      currentZoom: 11.5,
      currentCenter: latLng(47.41322, -1.219482),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl:false,
      },
      showMap: true,
      events:cacheEvents,
      dialog: false,
      dialogText: "",
      dialogSubtitle: "",
      addEventDialog: false,
      isAddingMarker: false,      
    };
  },
  mounted() {
    EventBus.$on('fab-action',this.FABAction)
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    centerMarker(marker)
    {
      var markerLatLng = marker.latlng;
      var point = this.$refs.eventsMap.mapObject.latLngToContainerPoint(markerLatLng);
      var newPoint = L.point([point.x, point.y - 100]);
      var newLatLng = this.$refs.eventsMap.mapObject.containerPointToLatLng(newPoint);
      this.$refs.eventsMap.mapObject.setView(newLatLng,14); 
    },
    joinEvent(id)
    {
      console.log(this.$user);
      let event = cacheEvents.find(element => element.id === id);
      // For some bizarre reason can't use "find" again to fetch joined events. 
      // Doing it the lazy way for now, should fix later.
      let existing = null;
      this.$user.joinedEvents.forEach(x => {
        if(x.id === id)
          existing = x;
      });

      if( existing == null)
      {
        this.$user.joinedEvents.push(event);
        this.dialogSubtitle = "Joined to event:" + event.name;
        this.dialogText = "Invite as many friends as you want!"
        this.dialog = true;
      }else{
        
        this.dialogSubtitle = "Event already joined";
        this.dialogText = "";
        this.dialog = true;
      }
    },
    FABAction()
    {
      this.addEventDialog = true;
    },
    clickHandler(e)
    {
      if(this.isAddingMarker)
      {
          //markers.push(e.latlng)
          this.createEvent(e.latlng);
          this.isAddingMarker = false;
          this.snackbar = false;
      }
    },
    createEvent(newLocation)
    {
      let newEvent = {
        id: cacheEvents.length,
        location: newLocation,
        name: this.createEventName, 
        picId: require('../assets/event-pictures/1.jpg'),
        creator: this.$user.name.first + " " + this.$user.name.last,
        participants: 1,
        time: this.date.toLocaleString(),
      }
      this.events.push(newEvent);
      this.$user.joinedEvents.push(newEvent);
      this.dialogSubtitle = "Succesfully created event: " + this.createEventName;
      this.dialogText = "Share this event with your friends!";
      this.dialog=true;
    },
    selectEventLocation()
    {
      this.isAddingMarker = true;
      this.addEventDialog = false;
      this.snackbar = true;
    },
  }
};
</script>
<style>
</style>